import * as ngCore from '@angular/core'

/**
 * A section of a data with the name for the section
 *
 * **Slots**
 * - *default* The content of the section
 *
 * **Inputs**
 * - {@link AtnDsSectionComponent.name|name}!
 *
 * @example
 * ```html
 * <atn-ds-section name="Section Name">
 *   <div>Section Content (can be angular component)</div>
 * </atn-ds-section>
 * ```
 */
@ngCore.Component({
  selector: 'atn-ds-section',
  standalone: true,
  styleUrls: ['./section.component.scss'],
  templateUrl: './section.component.html',
})
export class AtnDsSectionComponent {
  /**
   * The name of the section
   */
  public readonly nameSg = ngCore.input<string | undefined>(undefined, {
    alias: 'name',
  })
}
